<template>
    <div ref="chartRef" :style="{ height, width }"></div>
</template>

<script>
import * as echarts from 'echarts';


export default {
    name: 'TrendChart',
    props: {
        width: { type: String, default: '100%' },
        height: { type: String, default: '400px' },
        // 动态传入 series 数据
        seriesData: { type: Array, default: () => [] },
        xAxisData: { type: Array, default: () => [] }
    },
    data: () => ({ chart: null }),
    watch: {
        seriesData: { handler() { this.renderChart() }, deep: true }
    },
    mounted() {
        this.chart = echarts.init(this.$refs.chartRef);
        this.renderChart();
        window.addEventListener('resize', this.chart.resize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.chart.resize);
        if (this.chart) this.chart.dispose();
    },
    methods: {
        renderChart() {
            const option = {
                tooltip: {
                    trigger: 'axis',
                    backgroundColor: 'rgba(255,255,255,0.9)',
                    extraCssText: 'box-shadow: 0 0 8px rgba(0,0,0,0.1);'
                },
                legend: {
                    left: '0',
                    top: '0',
                    icon: 'rect',
                    itemWidth: 14,
                    itemHeight: 4
                },
                // --- 关键修改：调整边距 ---
                grid: {
                    left: '50',      // 增加左边距
                    right: '50',     // 增加右边距
                    top: '60',       // 增加顶边距，防止跟左上角图例太挤
                    bottom: '40',    // 显著增加底边距，确保 X 轴文字有空间
                    containLabel: true // 让 ECharts 自动计算标签占用的空间
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: this.xAxisData,
                    axisLine: { lineStyle: { color: '#f0f0f0' } },
                    axisLabel: {
                        color: '#999',
                        fontSize: 12,
                        margin: 15,       // 文字距离轴线的距离
                        interval: 'auto', // 自动计算间隔，防止文字重叠挤在一起
                        // 如果日期还是显示不全，可以取消下面这行的注释尝试旋转
                        // rotate: 30 
                    }
                },
                yAxis: {
                    type: 'value',
                    axisLabel: { show: false },
                    axisTick: { show: false },
                    axisLine: { show: false },
                    splitLine: { lineStyle: { type: 'dashed', color: '#f5f5f5' } }
                },
                series: this.seriesData.map(item => ({
                    name: item.name,
                    type: 'line',
                    data: item.data,
                    smooth: true,
                    showSymbol: false,
                    lineStyle: { width: 2 },
                    areaStyle: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0, color: item.color + '33' },
                            { offset: 1, color: item.color + '00' }
                        ])
                    },
                    itemStyle: { color: item.color }
                }))
            };
            this.chart.setOption(option, true); // true 表示不合并旧的 option
        }
    }
};
</script>